import {
  ReceiveDocumentLinkActions,
  ReceiveDocumentLinkActionTypes
} from './receive-document-link.actions';
import { initialState, State } from './receive-document-link.state';

export function reducer(
  state = initialState,
  action: ReceiveDocumentLinkActions,
): State {

  switch (action.type) {

    case ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK:
      return {
        ...state,
        payload: action.payload,
        loading: true,
      };

    case ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        payload: action.payload,
        errorData: null,
      };

    case ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK_FAILURE:
      return {
        ...state,
        success: false,
        loading: false,
        errorData: action.payload.error,
      };

    case ReceiveDocumentLinkActionTypes.CLEAR_RECEIVE_DOCUMENT:
      return initialState;

    default: {
      return state;
    }
  }
}
